var EventEmitter = require('event-emitter-es6');
export default class BaseModel extends EventEmitter{
    constructor() {
        super();
        this.uid=window.$manager.getUid();
    }
}